import styled from 'styled-components';

export const BetRibbon = styled.div`
  padding: 0px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  font-size: 10px;
  background-color: ${props => props.theme.colors.betLabel};
  margin-left: 5px;
  color: ${props => props.theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${props => (props.isTitleNarrowMedium ? `${props.theme.fontSets.narrowMedium}` : `${props.theme.fontSets.narrowRegular}`)};
  ${props => props.theme.mediaQueries.tablet_big_down}{
    height: 17px;
    width: 17px;
    font-size: 8px;
  }
`;

export const BetFooterContainer = styled.div`
  display: flex;
  font-weight: bold;
  padding: 30px;
  border-top: 1px solid ${props => props.theme.colors.borderColor};
`;



// WEBPACK FOOTER //
// ./src/components/BetFooter/styles.js